import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { CustomValidators } from '../custom-validator/custom-validator.component';

@Directive({
  selector: '[appSecureInput]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: SecureInputDirective,
      multi: true
    }
  ]
})
export class SecureInputDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return CustomValidators.secureInput(control);
  }
}
